module.exports = __webpack_public_path__ + "static/media/home.01cbb2fb.svg";